import { render, staticRenderFns } from "./WhiteboardLeftToolbar.vue?vue&type=template&id=1f67c8b3&scoped=true&"
import script from "./WhiteboardLeftToolbar.vue?vue&type=script&lang=js&"
export * from "./WhiteboardLeftToolbar.vue?vue&type=script&lang=js&"
import style0 from "./WhiteboardLeftToolbar.vue?vue&type=style&index=0&id=1f67c8b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67c8b3",
  null
  
)

export default component.exports